import template from './atm_count_print.html';
import controller from './atm_count_print.controller';
import './atm_count_print.scss';

let ATMCountPrintComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default ATMCountPrintComponent;


// WEBPACK FOOTER //
// ./client/app/components/atm_count/print/atm_count_print.component.js